<!--
 * @Author: cgh
 * @Date: 2022-08-01 10:53:11
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:53:49
 * @Description: 评估项目管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        评估项目
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="openNavTab({ name: 'jxxfPgxmAdd' })"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          :rules="filterParamsRules"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="委托单位"
                prop="wtdw"
              >
                <el-input
                  v-model.trim="filterParams.wtdw"
                  class="c-form__input"
                  placeholder="委托单位"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="报告编号"
                prop="bgbh"
              >
                <el-input
                  v-model.trim="filterParams.bgbh"
                  class="c-form__input"
                  placeholder="请输入报告编号"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="状态"
                prop="ztDm"
              >
                <el-select
                  v-model="filterParams.ztDm"
                  clearable
                  multiple
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in ztType"
                    :key="item.id"
                    :value="item.id"
                    :label="item.text"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div class="l-page__body l-page--search__body">
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="tableList"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template #xmmc="scope">
              <!-- @click="openNavTab({ name: 'jxxfPgxmDetail',params: { id: scope.row.id, type:'pgxm' } })" -->
              <el-link
                type="primary"
                @click="openNavTab({ name: 'jxxfPgxmDetail',params: { id: scope.row.id } })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <template #bgbh="scope">
              <el-link
                type="primary"
                :disabled="!scope.row.bgbh"
                @click="openNavTab({ name: 'jxxfPgsybg', query: { xmId: scope.row.id } })"
              >
                {{ scope.row.bgbh }}
              </el-link>
            </template>
            <template #pgrq="scope">
              {{ scope.row.pgrqq | date("yyyy-MM-dd") }} ~ {{ scope.row.pgrqz | date("yyyy-MM-dd") }}
            </template>
            <el-table-column
              prop="enabled"
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <k-button
                  v-if="scope.row.xmzt === 'WKS' || scope.row.xmzt === 'DSC' || scope.row.xmzt === 'ZXZ' "
                  btn-text="编辑"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="openNavTab({ name: 'jxxfPgxmEdit', params: { id: scope.row.id } })"
                />
                <k-button
                  v-if="!scope.row.bgbh && (scope.row.xmzt === 'WKS' || scope.row.xmzt === 'DSC' || scope.row.xmzt === 'ZXZ')"
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  plain
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>

      <div class="o-tips">
        已出过报告的项目不可删除
      </div>
    </div>
    <!-- 页面主内容：查询列表 End -->
  </div>
</template>

<script>
import { pgxmManageService } from './pgxm.service.js';
export default {
  name: 'Pgxm',
  data () {
    return {
      loading: false, // 页面是否loading状态
      list: [{
        label: '选项1',
        value: 'android'
      }, {
        label: '选项2',
        value: 'ios'
      }],
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmmc: null, // 项目名称
        ztDm: [],
        bgbh: null,
        wtdw: null
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      filterParamsRules: {
        // cjsj: [this.$HMValidator.dateRange('创建时间')]
      },
      /* 表单校验规则 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'wtdw', label: '委托单位', align: 'left', minWidth: '180', type: 'text' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'left', minWidth: '160', type: 'text' },
        { key: 'pgrq', slotName: 'pgrq', label: '评估日期', align: 'center', width: '160', type: 'text' },
        { key: 'yjcsl', label: '已检查', align: 'right', width: '80', type: 'text' },
        { key: 'nrrs', label: '纳入项', align: 'right', width: '80', type: 'text' },
        { key: 'bfhsl', label: '不符合', align: 'right', width: '80', type: 'text' },
        { key: 'bsysl', label: '不适用', align: 'right', width: '80', type: 'text' },
        { key: 'wfpdsl', label: '无法判定', align: 'right', width: '100', type: 'text' },
        { key: 'wtsl', label: '问题数', align: 'right', width: '80', type: 'text' },
        { key: 'xmztMc', label: '状态', align: 'left', width: '90', type: 'text' }
      ]
      /* 表格列配置End */

    };
  },
  computed: {
    // 状态类型
    ztType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.JX_PG_XMZT) {
        return enums.JX_PG_XMZT;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      if (this.$refs.filterParams) {
        this.$refs.filterParams.validate(valid => {
          if (valid) {
            this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
            this.search();
          }
        });
      } else {
        this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
        this.search();
      }
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      pgxmManageService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },

    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此评估项目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgxmManageService.delete(_row.id, _row.lockVersion)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
<style scoped lang="scss">
.o-tips {
  position: absolute;
  top: 4px;
  right: 12px;
  z-index: 9;
  padding-left: 8px;
  border-left: 0;
  color: #f56c6c;
  background-color: #fef0f0;
}
</style>
